import React from 'react';
import { motion } from 'framer-motion';
import { Sign } from '../../data/signs';
interface SignPreviewNoteProps {
  sign: Sign;
}
export function SignPreviewNote({
  sign
}: SignPreviewNoteProps) {
  return <div className="w-full flex flex-col items-center justify-center pt-20 pb-8 px-4" data-id="element-965">
      <motion.div className="inline-flex items-center gap-3 mb-4" initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-966">
        <div className="h-px w-8 sm:w-12" style={{
        background: `linear-gradient(90deg, transparent, ${sign.colors.accent})`
      }} data-id="element-967" />
        <span className="sm:text-[11px] tracking-[0.4em] uppercase font-serif text-[14px]" style={{
        color: sign.colors.accent
      }} data-id="element-968">
          Vista Previa
        </span>
        <div className="h-px w-8 sm:w-12" style={{
        background: `linear-gradient(90deg, ${sign.colors.accent}, transparent)`
      }} data-id="element-969" />
      </motion.div>

      <motion.p className="text-lg sm:text-xl md:text-2xl font-serif italic text-center max-w-2xl px-2" style={{
      color: '#F5F0E1',
      textShadow: `0 0 20px ${sign.colors.primary}40`
    }} initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} data-id="element-970">
        {sign.content.previewNote}
      </motion.p>
    </div>;
}